import React from "react";

import { Button, ButtonProps } from "react-bootstrap";

import classNames from "classnames";
import { ReactSVG } from "react-svg";

import { isTruthy } from "../util";

export const IconButton = ({ src, text, ...rest }: ButtonProps & { src: string; text?: string }) => {
  return (
    <Button
      {...rest}
      className={classNames("icon", {
        text: isTruthy(text),
      })}
    >
      <ReactSVG src={src} />
      {text && <span className="b3">{text}</span>}
    </Button>
  );
};
